<div class="row" *ngIf="!this.noMap">
  <div class="col map-container-wrapper" style="height: 400px;">
    <!-- <p-gmap [options]="mapOptions" [style]="{'width':'100%','height': this.height}" [overlays]="overlays" 
        (onMapReady)="setMap($event)">
      </p-gmap> -->
      <mgl-map class="map-container" [class.has-print-snapshot]="printSnapshotSrc" [style]="'mapbox://styles/mapbox/satellite-streets-v11'"
            [zoom]="[3.5]" [center]="[-98, 38.88]" (mapLoad)="setMap($event)" [preserveDrawingBuffer]="true">
      </mgl-map>
      <img *ngIf="printSnapshotSrc" [src]="printSnapshotSrc" class="print-map-snapshot" alt="Map">
    </div>
  </div>
<div class="row" *ngIf="this.noMap">
  <div class="col-12">
    <!-- <lottie-animation-view [options]="lottieConfig"></lottie-animation-view> -->
    <ng-lottie [options]="lottieConfig"></ng-lottie>

  </div>
  <div class="col-12 text-center">
    <h3>No map found...</h3>
  </div>
</div>